import React, { useState } from 'react';
import './GeofenceManager.css';

const GeofenceManager = ({ 
  customGeofences, 
  beachLocations, 
  onDeleteGeofence, 
  onDeleteBeachGeofence,
  isOpen, 
  onClose 
}) => {
  const [selectedGeofence, setSelectedGeofence] = useState(null);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [deletingGeofence, setDeletingGeofence] = useState(null);

  const handleDeleteClick = (geofence, type = 'custom') => {
    setSelectedGeofence({ ...geofence, type });
    setShowDeleteConfirm(true);
  };

  const handleDeleteConfirm = async () => {
    if (!selectedGeofence) return;

    setDeletingGeofence(selectedGeofence.id);
    
    try {
      if (selectedGeofence.type === 'custom') {
        await onDeleteGeofence(selectedGeofence.id, selectedGeofence.name);
      } else {
        await onDeleteBeachGeofence(selectedGeofence.id, selectedGeofence.name);
      }
      
      setShowDeleteConfirm(false);
      setSelectedGeofence(null);
    } catch (error) {
      console.error('Error deleting geofence:', error);
      alert('Error deleting geofence. Please try again.');
    } finally {
      setDeletingGeofence(null);
    }
  };

  const handleDeleteCancel = () => {
    setShowDeleteConfirm(false);
    setSelectedGeofence(null);
  };

  if (!isOpen) return null;

  return (
    <div className="geofence-manager-overlay">
      <div className="geofence-manager">
        <div className="geofence-manager-header">
          <h3>Manage Geofences</h3>
          <button className="close-button" onClick={onClose}>
            ×
          </button>
        </div>
        
        <div className="geofence-manager-body">
          {/* Custom Geofences Section */}
          <div className="geofence-section">
            <h4>Custom Geofences ({customGeofences.length})</h4>
            {customGeofences.length === 0 ? (
              <p className="no-geofences">No custom geofences created yet.</p>
            ) : (
              <div className="geofence-list">
                {customGeofences.map(geofence => (
                  <div key={geofence.id} className="geofence-item">
                    <div className="geofence-info">
                      <h5>{geofence.name}</h5>
                      <p className="geofence-description">
                        {geofence.description || 'No description'}
                      </p>
                      <div className="geofence-details">
                        <span>Vertices: {geofence.vertices || geofence.coordinates?.length || 0}</span>
                        <span>Type: {geofence.type || 'Custom'}</span>
                        <span>Created: {new Date(geofence.created_at).toLocaleDateString()}</span>
                      </div>
                    </div>
                    <div className="geofence-actions">
                      <button 
                        className="delete-button"
                        onClick={() => handleDeleteClick(geofence, 'custom')}
                        disabled={deletingGeofence === geofence.id}
                      >
                        {deletingGeofence === geofence.id ? 'Deleting...' : 'Delete'}
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Beach Geofences Section */}
          <div className="geofence-section">
            <h4>Beach Geofences ({beachLocations.length})</h4>
            {beachLocations.length === 0 ? (
              <p className="no-geofences">No beach geofences available.</p>
            ) : (
              <div className="geofence-list">
                {beachLocations.map(beach => (
                  <div key={beach.id} className="geofence-item">
                    <div className="geofence-info">
                      <h5>{beach.name}</h5>
                      <p className="geofence-description">
                        {beach.description || 'Beach area geofence'}
                      </p>
                      <div className="geofence-details">
                        <span>Area: {beach.area || 'Unknown'}</span>
                        <span>Type: {beach.type || 'Beach'}</span>
                        <span>Vertices: {beach.vertices || beach.polygon?.length || 0}</span>
                      </div>
                    </div>
                    <div className="geofence-actions">
                      <button 
                        className="delete-button"
                        onClick={() => handleDeleteClick(beach, 'beach')}
                        disabled={deletingGeofence === beach.id}
                      >
                        {deletingGeofence === beach.id ? 'Deleting...' : 'Delete'}
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
        
        <div className="geofence-manager-footer">
          <button className="close-manager-button" onClick={onClose}>
            Close
          </button>
        </div>
      </div>

      {/* Delete Confirmation Modal */}
      {showDeleteConfirm && (
        <div className="delete-confirm-overlay">
          <div className="delete-confirm-modal">
            <h4>Confirm Deletion</h4>
            <p>
              Are you sure you want to delete the geofence "{selectedGeofence?.name}"?
            </p>
            <p className="warning-text">
              This action cannot be undone.
            </p>
            <div className="delete-confirm-actions">
              <button 
                className="cancel-delete-button" 
                onClick={handleDeleteCancel}
                disabled={deletingGeofence}
              >
                Cancel
              </button>
              <button 
                className="confirm-delete-button" 
                onClick={handleDeleteConfirm}
                disabled={deletingGeofence}
              >
                {deletingGeofence ? 'Deleting...' : 'Delete'}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default GeofenceManager;
